// import React from "react";
// import UserNavbar from "../../components/common/UserNavbar";
// import { Navigate } from "react-router-dom";
// import UserFooter from "../../components/common/UserFooter";
// import { FaWhatsapp } from "react-icons/fa6";

// const UserLayout = (props) => {
//   const MessageButton = () => {
//     const openMessageModal = () => {
//       const phoneNumber = "919393991563";
//       const whatsappUrl = `https://wa.me/${phoneNumber}`;
//       window.open(whatsappUrl, "_blank");
//     };

//     return (
//       <button
//         className="fixed right-4 bottom-4 p-2 bg-[#f5e7e7] rounded-full shadow-lg hover:bg-[#f8bdbd] hover:scale-105 ease-in-out duration-300 focus:outline-none transition-transform transform-gpu"
//         onClick={openMessageModal}
//       >
//         <FaWhatsapp size={32} color="#10b416" />
//       </button>
//     );
//   };

//   return (
//     <React.Fragment>
//       <UserNavbar />
//       {props.children}
//       <UserFooter />

//       {/* <MessageButton /> */}
//     </React.Fragment>
//   );
// };

// export default UserLayout;

import React from "react";
import UserNavbar from "../../components/common/UserNavbar";
import { Navigate } from "react-router-dom";
import UserFooter from "../../components/common/UserFooter";
import { FaWhatsapp } from "react-icons/fa6";

const UserLayout = (props) => {
  const MessageButton = () => {
    const openMessageModal = () => {
      const phoneNumber = "+917017774127";
      const whatsappUrl = `https://wa.me/${phoneNumber}`;
      window.open(whatsappUrl, "_blank");
    };

    return (
      <div className="fixed right-6 bottom-6 z-50">
        {/* Pulsing background rings */}
        <div className="absolute inset-0 rounded-full bg-green-500 opacity-20 animate-ping"></div>
        <div className="absolute inset-0 rounded-full bg-green-500 opacity-30 animate-pulse"></div>

        {/* Main button */}
        <button
          className="relative group bg-gradient-to-br from-green-400 to-green-600 hover:from-green-500 hover:to-green-700 text-white p-4 rounded-full shadow-2xl hover:shadow-green-500/50 transform hover:scale-110 active:scale-95 transition-all duration-300 ease-out focus:outline-none focus:ring-4 focus:ring-green-300/50"
          onClick={openMessageModal}
          aria-label="Contact us on WhatsApp"
        >
          {/* Glowing effect */}
          <div className="absolute inset-0 rounded-full bg-green-400 opacity-0 group-hover:opacity-30 blur-xl transition-opacity duration-300"></div>

          {/* Icon container with subtle rotation */}
          <div className="relative transform group-hover:rotate-12 transition-transform duration-300">
            <FaWhatsapp size={28} className="drop-shadow-lg" />
          </div>

          {/* Tooltip */}
          <div className="absolute right-full mr-3 top-1/2 transform -translate-y-1/2 bg-gray-900 text-white text-sm px-3 py-2 rounded-lg shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap pointer-events-none">
            <span>Chat with us on WhatsApp</span>
            <div className="absolute left-full top-1/2 transform -translate-y-1/2 border-l-4 border-l-gray-900 border-t-4 border-t-transparent border-b-4 border-b-transparent"></div>
          </div>
        </button>

        {/* Optional: Message indicator dot */}
        <div className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full border-2 border-white animate-bounce">
          <div className="w-full h-full bg-red-400 rounded-full animate-ping"></div>
        </div>
      </div>
    );
  };

  return (
    <React.Fragment>
      <UserNavbar />
      {props.children}
      <UserFooter />

      <MessageButton />
    </React.Fragment>
  );
};

export default UserLayout;
